import React, { useState } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  Navigate,
} from "react-router-dom";
import TopBar from "../../layouts/TopBar";
import SideBar from "../../layouts/SideBar";
import ValidateAdmission from "../auth/admissionValidation";
import AccountOtp from "../auth/createAcountOtp";
import ResetOtp from "../auth/passwordResetOtp";
import Login from "../auth/login";
import SetPassword from "../auth/setPassword";
import ForgotPassword from "../auth/forgotPassword";
import StudentProfile from "../studentProfile";
import ApplyCourse from "../courseApplication";
import ChangeCourse from "../courseChange";
import Deferement from "../deferementApplication";
import ApplicationsHistory from "../applicationsHistory";
import Transcript from "../transcript";
import Newsletter from "../newsletter";
import PageNotFound from "../pageNotFound";

export default function Router() {
  const Layout = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const toggleSidebar = () => {
      setIsSidebarOpen(!isSidebarOpen);
    };

    const closeSidebar = () => {
      setIsSidebarOpen(false);
    };

    return (
      <div className="min-h-screen bg-gray-50">
        {/* Fixed TopBar with Sidebar Toggle */}
        <div className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm border-b border-gray-200">
          <div className="flex items-center justify-between px-4 py-3">
            {/* Mobile Menu Button */}
            <button
              onClick={toggleSidebar}
              className="lg:hidden p-2 rounded-lg text-gray-600 hover:bg-gray-100 hover:text-gray-900 transition-colors duration-200"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>

            {/* TopBar Content */}
            <div className="flex-1 lg:ml-0">
              <TopBar />
            </div>
          </div>
        </div>

        {/* Mobile Sidebar Overlay */}
        {isSidebarOpen && (
          <div className="fixed inset-0 z-40 lg:hidden" onClick={closeSidebar}>
            <div className="fixed inset-0 bg-gray-600 bg-opacity-75 transition-opacity" />
          </div>
        )}

        {/* Sidebar */}
        <div
          className={`fixed top-0 left-0 z-40 h-full w-64 pt-16 transition-transform duration-300 ease-in-out lg:translate-x-0 ${
            isSidebarOpen ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          <div className="h-full bg-white shadow-lg border-r border-gray-200">
            <SideBar />
          </div>
        </div>

        {/* Main Content Area */}
        <div className="lg:ml-64 pt-16">
          <main className="min-h-screen bg-gray-50">
            <div className="px-4 py-6 sm:px-6 lg:px-8">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    );
  };

  const BrowserRoutes = createBrowserRouter([
    {
      path: "/",
      element: (
        <RequireAuth redirectTo="/auth/validate-admission">
          <Layout />
        </RequireAuth>
      ),
      children: [
        {
          index: true,
          element: <StudentProfile />,
        },
        {
          path: "/apply",
          element: <ApplyCourse />,
        },
        {
          path: "/change-course",
          element: <ChangeCourse />,
        },
        {
          path: "/defer",
          element: <Deferement />,
        },
        {
          path: "/view-requests",
          element: <ApplicationsHistory />,
        },
        {
          path: "/transcript",
          element: <Transcript />,
        },
        {
          path: "/transcript/:studentCourseId",
          element: <Transcript />,
        },
        {
          path: "/newsletter",
          element: <Newsletter />,
        },
      ],
    },
    {
      path: "/auth/validate-admission",
      element: <ValidateAdmission />,
    },
    {
      path: "/auth/login",
      element: <Login />,
    },
    {
      path: "/auth/account-otp",
      element: <AccountOtp />,
    },
    {
      path: "/auth/reset-otp",
      element: <ResetOtp />,
    },
    {
      path: "/auth/set-password",
      element: <SetPassword />,
    },

    {
      path: "/auth/password-reset",
      element: <ForgotPassword />,
    },

    {
      path: "*",
      element: <PageNotFound />,
    },
  ]);

  function RequireAuth({ children, redirectTo }) {
    let isLoggedIn = getAuth();
    return isLoggedIn ? children : <Navigate to={redirectTo} />;
  }

  function getAuth() {
    const token = sessionStorage.getItem("token");
    if (!token || token == null || token === "") {
      return false;
    } else {
      return true;
    }
  }

  return <RouterProvider router={BrowserRoutes}></RouterProvider>;
}
